import React from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { ReactComponent as Icon } from '#web-components/assets/icons/openFullScreen.svg';

import styles from './OpenFullScreenIcon.styles';

type OpenFullScreenIconProps = {
  className?: string;
};

const useStyles = makeStyles(styles, { name: 'ArrowLeftIcon' });

export default function OpenFullScreenIcon({ className }: OpenFullScreenIconProps) {
  const classes = useStyles();
  return (
    <span className={clsx(classes.icon, className)}>
      <Icon />
    </span>
  );
}
